<template>
    <tr class="cart-table__row product-card">

        <td class="cart-table__column cart-table__column--diagram"
            data-title="Diagram"  v-if="categorydiagramimage">
            <span class="text-cart-diagram-number">{{diagram}}</span>
        </td>

        <td class="cart-table__column cart-table__column--image">
            <div class="image image--type--product modal-thumbnail">
                <router-link :to="productDetailsLink" class="image__body" v-if="image_src != null">
                    <img class="image__tag" :src="image_src" :alt="product.IMDESC" />
                </router-link>
            </div>
        </td>

        <td class="cart-table__column cart-table__column--product">
            <router-link :to="productDetailsLink" class="cart-table__product-name">
                {{product.IMDESC}}
            </router-link>
            <div class="text-cart-item-number">
            <span class="text-cart-item-number">Item: {{product.DMITMC}}</span>
            </div>
            <div class="text-cart-item-manufacturer">
            <span class="text-cart-item-manufacturer">Manufacturer: {{product.IUUMFG}}</span>
            </div>
        </td>

        <td class="cart-table__column cart-table__column--price" data-title="Price">
            <p class="cart-table--price">
                <strong><span class="notranslate">{{ toUSD(product.PRC) }}</span></strong>
                <template v-if="(product.EILSTP > 0)">
                    <br />
                    <!-- List Price: <span class="notranslate">{{ toUSD(product.EILSTP) }}</span> -->
                </template>
            </p>
        </td>

        <td class="cart-table__column cart-table__column--quantity"
            data-title="Quantity" v-if="product.IMKITM != 'Y'">
            <base-quantity-input v-model="quantity" @changedQty="changedQty"></base-quantity-input>
            <div class="text-cart-item-number">REQ: {{product.DXQTY}} {{product.IMKITM}} KIT </div>
        </td>

        <!-- v-if="!isItemKit" -->
        <td class="cart-table__column cart-table__column--numeral" data-title="Status" v-if="product.IMKITM != 'Y'">
            <availability-display :stock-quantity="stockqty" />
            <div class="btn-check-stock" v-if="showCheckStock">
                <router-link :to="'/order-entry-check-stock/' + product.manufacturer + '/' + clearProductName" class="btn btn-micro btn-dark-grey btn-check-stock" v-if="showCheckStock">Check Stock</router-link>
            </div>
        </td>

        <td class="cart-table__column cart-table__column--total" data-title="Total">
            <strong>{{linetotal}}</strong>
        </td>

        <td class="cart-table__column cart-table__column--remove" v-if="product.IMKITM != 'Y'">
            <button class="product-card__addtocart-icon" type="button" aria-label="Add to cart" @click.prevent="AddToCart">
                <svg width="20" height="20">
                    <circle cx="7" cy="17" r="2"></circle>
                    <circle cx="15" cy="17" r="2"></circle>
                    <path
                        d="M20,4.4V5l-1.8,6.3c-0.1,0.4-0.5,0.7-1,0.7H6.7c-0.4,0-0.8-0.3-1-0.7L3.3,3.9C3.1,3.3,2.6,3,2.1,3H0.4C0.2,3,0,2.8,0,2.6
                        V1.4C0,1.2,0.2,1,0.4,1h2.5c1,0,1.8,0.6,2.1,1.6L5.1,3l2.3,6.8c0,0.1,0.2,0.2,0.3,0.2h8.6c0.1,0,0.3-0.1,0.3-0.2l1.3-4.4
                        C17.9,5.2,17.7,5,17.5,5H9.4C9.2,5,9,4.8,9,4.6V3.4C9,3.2,9.2,3,9.4,3h9.2C19.4,3,20,3.6,20,4.4z">
                    </path>
                </svg>
            </button>
        </td>
        <td class="cart-table__column cart-table__column--remove" v-else>
            <div style="width: 150px;"></div>
        </td>

    </tr>
</template>

<style scoped>

    .cart-table__column .product-card__addtocart-icon{
        position: relative;
        border: none;
        padding: 8px;
        border-radius: 2px;
        background: transparent;
        color: #ccc;
        z-index: 0;
        -webkit-transition: color .2s;
        transition: color .2s;
    }

    .cart-table__column .product-card__addtocart-icon svg {
        display: block;
        fill: currentColor;
    }

    .cart-table__row:hover .product-card__addtocart-icon:before, .cart-table__row:active .product-card__addtocart-icon:before {
        -webkit-transform: scale(1);
        transform: scale(1);
        background: #e52727;
    }

</style>

<script>
import Price from '../../../mixins/price.js';
import MixinCart from '../../../mixins/cart.js';
import AvailabilityDisplay from './AvailabilityDisplay';
import CloudinaryApi from '../../../utilities/cloudinaryapi';
import * as GCONST from '../../../constants.js';
import axiosvl from "../../../axios/axios-vl.js";
import { mapGetters } from 'vuex';

export default {
    components: {
        "availability-display": AvailabilityDisplay
    },
    props : {
        product : {
            type: Object
        },
        categorydiagramimage : {
            type: String
        }
    },
    mixins : [
        Price,
        MixinCart
    ],
    data() {
        return {
            quantity : 1,
            lineTotal: 0,
            image_src: null,
            kit_master: {},
            kit_gtotal: 0,
            kitc_qty: 0,
            kit_items: [],

            isItemKit: false,
        }
    },
    computed: {
        
        ...mapGetters([
            'customerIndicator',
            'storefrontAttributes'
        ]),

        showCheckStock() {
            if (this.storefrontAttributes.length > 0) {
                let onHandQuantityRule = this.storefrontAttributes.find(attribute => attribute.indicator === this.customerIndicator && attribute.type === 'OHQ').value;
                return this.customerIndicator === 'B' && onHandQuantityRule != '5';
            } else {
                return false;
            }
        },

        stockqty() {

            return (this.$store.getters.customerIndicator == 'B') ? this.product.QTYAVL : this.product.TOTOH;
        },
        linetotal() {
            let total = this.product.PRC * this.quantity;
            return this.toUSD(total);
        },
        productDetailsLink() {
            const clearProductName = encodeURIComponent(this.product.DMITMC);

            if (this.product.IMMFGC != 'KIT')
                return '/part/' + this.product.IMMFGC + '/' + clearProductName + '/' + this.product.mfgSeo + '/' + this.product.itemSeo;
            else
                return '/kit-group/' + this.product.IMMFGC + '/' + clearProductName;
        },
        diagram() {
            // console.log(this.product.DMIMAG);
            const d = this.product.DMIMAG;

            if(d.indexOf(",") > 0){
                return d;
            }
            
            // if (d != ''){
            //     return parseInt(d);
            // }
            
            return d;
        },

        clearProductName(){
            const clearProductName = encodeURIComponent(this.product.sku);

            return clearProductName;
        }
    },
    methods : {
        changedQty() {
            // let c = this.quantity * product.price
        },
        AddToCart() {
            if (this.product.IUUMFG != 'KIT')
                this.itemToCart();
            else
                this.kitToCart();
        },


        itemToCart(){
            this.$store.dispatch("message/clearKeyedMessage", "PartsDiagramGroup");

            const linetotal = this.quantity * this.product.PRC;

            // console.log(this.product);

            let productData = {
                ID: this.product.DMITMC,
                item: this.product.DMITMC,
                desc: this.product.IMDESC,
                manufacturer: this.product.IUUMFG,
                // image: this.product.image,
                image: this.image_src,
                quantity: this.quantity,
                corecharge: 0.0,
                yourprice: this.product.PRC,
                listprice: this.product.EILSTP,
                shipping: 0,
                linetotal: linetotal,
                stockquantity: (this.$store.getters.customerIndicator == 'B') ? this.product.QTYAVL : this.product.TOTOH,

                // new fields
                XRMFGC: this.product.XRMFGC,
                XRITMC: this.product.XRITMC,
                IMIGSA: this.product.IMIGSA,
                IMISVALID: this.product.IMISVALID,
            }
           
            let validationresult = this.addToCartValidation(productData);

            if (validationresult.status === 'OK') {
              this.$store.dispatch("cart/addToCart", productData);
            } else {
              let storedmessages = [];
              storedmessages.push(validationresult.message);

              this.$store.dispatch("message/addKeyedMessage", {
                "key": "PartsDiagramGroup",
                "messages": storedmessages
              });
            }
        },

        async fetchKitInfo() {
            return await axiosvl.post(this.$store.getters['api/kit_master_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                        "KMMMFG": { "value": this.product.IUUMFG },
                        "KMMITM": { "value": this.product.DMITMC },
                    },   
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const KITPARTS = response.data.webroutine.lists.KITPARTS.entries;
                const ITMSIZES = response.data.webroutine.lists.ITMSIZES.entries;
                const PARTLOC = response.data.webroutine.lists.PARTLOC.entries;

                // const MPARTS = response.data.webroutine.lists.MPARTS.entries;
                this.kit_sizes = ITMSIZES;
                const kitm_loc = PARTLOC.find(loc => (loc.EIITMC == this.product.DMITMC && loc.EIMFGC == this.product.IUUMFG));
                // console.log(kitm_loc);
                const clApi = new CloudinaryApi;
                clApi.item_sku = this.product.DMITMC;
                clApi.manufacturer_code = this.product.IUUMFG;

                return clApi.vlImageByMeta(GCONST.CL_META_ITEM_SKU, GCONST.Product_Thumbnail).then(imgURL => {
                    let kitm_image = '';
                    if(imgURL){
                        kitm_image = imgURL;
                    }else{
                        kitm_image = GCONST.IMAGE_PLACEHOLDER;
                    }

                    this.kit_master = {
                        ID: this.product.IMITMC,
                        item: this.product.IMITMC,
                        desc: fields.KITDSC.value,
                        long_desc: fields.DDTXT0K.value + ' ' + fields.DDTXT1K.value + ' ' + fields.DDTXT2K.value + ' ' + fields.DDTXT3K.value + ' ' + fields.DDTXT4K.value + ' ' + fields.DDTXT5K.value + ' ' + fields.DDTXT6K.value + ' ' + fields.DDTXT7K.value + ' ' + fields.DDTXT8K.value + ' ' + fields.DDTXT9K.value,
                        manufacturer: this.product.manufacturer,
                        manufacturername: '',
                        yourprice: fields.KITPRC.value,
                        corecharge: fields.KITCOR.value,
                        listprice: fields.KITLST.value,
                        carrier: '',

                        // locations
                        locationid: fields.CMDLOC.value,
                        locationname: kitm_loc.LCNAME,
                        locationcity: kitm_loc.LCLOCC,
                        locationstate: kitm_loc.LCTAXC,

                        XRITMC: '',
                        XRMFGC: '',
                        // xref_mfg_desc: (fields.XRMFGC.value != '') ? xref_mfg_desc.MFG_DESC : '',
                        IMIGSA: fields.KITIGSA.value,
                        IMISVALID: '',
                        image: kitm_image,
                        kit_items: [],
                    };
                    // console.log(this.kit_master);
                    this.kit_items = [];
                    
                    KITPARTS.forEach(kit => {
                        // const sizes = ITMSIZES.filter(s => s.QITEMNUM == kit.EIITMC && s.QSIZEITM != '' && s.QMFR == kit.EIMFGC);
                        // console.table(sizes);
                        const kitc_loc = PARTLOC.find(loc => (loc.EIITMC == kit.EIITMC && loc.EIMFGC == kit.EIMFGC));
                        // console.log(kit);
                        // add substitutes to the separate var array
                        if(kit.CINFO == 'SUBSTITUTE'){
                            return;
                        }

                        if(kit.KCRQTY == 0){
                            return;
                        }

                        this.kitc_qty += this.quantity * kit.KCRQTY;
                        
                        this.kit_items.push({
                            info: kit.CINFO,
                            item: kit.EIITMC,
                            desc: kit.IMDESC,
                            manufacturer: kit.EIMFGC,
                            manufacturername: kit.MCNAME,

                            yourprice: kit.EIEXCP,
                            corecharge: kit.EICORP,
                            listprice: kit.EILSTP,

                            backorder: '',
                            req_qty: kit.KCRQTY,
                            quantity: this.quantity * kit.KCRQTY,
                            stockquantity: (this.$store.getters.customerIndicator == 'B') ? kit.QTYAVL : kit.TOTOH,
                            carrier: '',

                            // locations
                            locationid: kitc_loc.ILLOC,
                            locationname: kitc_loc.LCNAME,
                            locationcity: kitc_loc.LCLOCC,
                            locationstate: kitc_loc.LCTAXC,
                            
                            XRITMC: kit.XRITMC,
                            XRMFGC: kit.XRMFGC,
                            IMIGSA: kit.IMIGSA,
                            IMISVALID: kit.IMISVALID,
                            KCSEQN: kit.KCSEQN,
                            EKKITF: 'C',
                            image: GCONST.IMAGE_PLACEHOLDER,

                            sizes: [],
                            alternatives: [],
                            origItem: '',
                        });
                    
                    });

                    this.kit_items.forEach(kit => {
                        const linetotal = (this.quantity * kit.req_qty) * kit.yourprice;
                        kit.linetotal = linetotal;
                        const clApi = new CloudinaryApi;
                        clApi.item_sku = kit.item;
                        clApi.manufacturer_code = kit.manufacturer;

                        clApi.vlImageByMeta(GCONST.CL_META_ITEM_SKU, GCONST.Product_Thumbnail).then(imgURL => {
                            kit.image = imgURL;
                            if(imgURL){
                                kit.image = imgURL;
                            }else{
                                kit.image = GCONST.IMAGE_PLACEHOLDER;
                            }
                        });

                        this.kit_master.kit_items.push(kit);
                        this.kit_gtotal += linetotal;
                    });

                    return this.kit_master;
                });
                
                // this.kit_master.kit_items = this.kit_items;

                // console.log(this.kit_master);
                // return this.kit_master;
             })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        /**
         * KIT MASTER to add to the cart
         */
        kitToCart() {

            this.fetchKitInfo().then(() => {
                // console.log(res);
                // get the kit item components that has quantity > 0
                // const kitc_items = this.kit_items.filter(c => c.quantity > 0);

                // loop through kit items
                // check in changed sizes if the item has change on sizes

                const kit = {
                    kitnumber   : this.product.DMITMC,
                    mfgcode     : this.product.IUUMFG,
                    EKKITF      : 'M',
                    kitqy       : this.quantity,
                    quantity    : this.kitc_qty,
                    backorder   : '',
                    corecharge  : this.kit_master.corecharge,
                    yourprice   : this.kit_master.yourprice,
                    kit_gtotal  : this.kit_gtotal,
                    desc        : this.kit_master.desc,
                    image       : this.kit_master.image,
                    sku         : this.kit_master.item,
                    carrier     : '',

                    locationid      : this.kit_master.locationid,
                    locationname    : this.kit_master.locationname,
                    locationcity    : this.kit_master.locationcity,
                    locationstate   : this.kit_master.locationstate,

                    kit_items   : this.kit_items,
                };

                // console.log(kit);
                // if(kit != undefined){
                //     return;
                // }
                this.$store.dispatch("cart/kitToCart", kit);
            });
        },
    },
    created() {
        // console.log(this.product);
        const clApi = new CloudinaryApi;
        // console.log(this.product.IUUMFG);
        // if (this.product.IUUMFG != 'KIT'){
        //     this.isItemKit = false;
        // }else{
        this.isItemKit = true;
        clApi.item_sku = this.product.DMITMC;
        clApi.manufacturer_code = this.product.IMMFGC;
        
        clApi.vlImageByMeta(GCONST.CL_META_ITEM_SKU, GCONST.Product_Thumbnail).then(imgURL => {
            if(imgURL){
                this.image_src = imgURL;
            }else{
                this.image_src = GCONST.IMAGE_PLACEHOLDER;
            }
        });
            // return;
        // }

        // if(this.product.image === '' || this.product.image === null){
        //     this.image_src = clApi.manufacturer_img(this.product.IMMFGC, GCONST.Product_Thumbnail);
        // }else{
        //     this.image_src = this.product.image;
        // }
    }
}
</script>